exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-container.card {\r\n  max-width: 475px;\r\n  padding: 40px 40px;\r\n}\r\n\r\n.card {\r\n  background-color: #F7F7F7;\r\n  padding: 20px 25px 30px;\r\n  margin: 0 auto 25px;\r\n  margin-top: 50px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.card-container2.card {\r\n  max-width: 675px;\r\n  padding: 40px 40px;\r\n}\r\n\r\n.card-containerImage.card {\r\n  max-width: 1075px;\r\n  max-height: 70%;\r\n  padding: 40px 40px;\r\n  overflow: scroll;\r\n}\r\n\r\n.card-containerImage2.card {\r\n  max-width: 1075px;\r\n  max-height: 40%;\r\n  padding: 40px 40px;\r\n  overflow: scroll;\r\n}\r\n\r\n.test {\r\n  max-width: 675px;\r\n  max-height: 40%;\r\n  padding: 40px 40px;\r\n  overflow: scroll;\r\n}\r\n\r\n.header-toolbar {\r\n  top: 0;\r\n  position: fixed;\r\n  z-index: 999;\r\n}\r\n\r\n.top {\r\n  overflow-y: hidden\r\n}\r\n\r\n/* Absolute Center Spinner */\r\n\r\n.loading {\r\n  position: fixed;\r\n  z-index: 999;\r\n  margin: auto;\r\n  top: 40%;\r\n  left: 50%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/doctor-filter/doctor-filter.component.css
// module id = ./src/app/doctor-filter/doctor-filter.component.css
// module chunks = main